/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Mcp_DisabledInputs */

const en_error_mcp_disabled = /** @type {(inputs: Error_Mcp_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The access through assistants and tokens is turned off.`)
};

/**
* | output |
* | --- |
* | "The access through assistants and tokens is turned off." |
*
* @param {Error_Mcp_DisabledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_mcp_disabled = /** @type {((inputs?: Error_Mcp_DisabledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Mcp_DisabledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_mcp_disabled(inputs)
});